import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { AutoComplete } from 'primeng/autocomplete';

import { ApiMember } from 'content-manager/src/app/core/open-api/content-manager-api-client';

@Component({
    selector: 'sc-search-member',
    templateUrl: './search-member.component.html',
    standalone: false
})
export class SearchMemberComponent {

    @Input()
    public members: ApiMember[];

    @Input()
    public emptyMessage: string;

    @Output()
    public readonly filter = new EventEmitter<string>();

    @Output()
    public readonly selectItem = new EventEmitter<ApiMember>();

    @ViewChild('autocomplete')
    private _autoComplete: AutoComplete;

    public selectedMember: ApiMember | null = null;

    private _blurOnHide = false;

    public completeMethod(event: { query: string; }): void {
        if (!event.query) {
            return;
        }

        this.filter.next(event.query);
    }

    public onSelect(member: ApiMember): void {
        this.selectItem.next(member);

        this.selectedMember = null;
        this._blurOnHide = true;
        if (this._autoComplete) {
            this._autoComplete.clear();
        }
    }

    public onHide(): void {
        if (this._blurOnHide) {
            this._blurOnHide = false;
            this._autoComplete?.inputEL?.nativeElement?.blur();
        }
    }
}
